import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLanguage = localStorage.getItem("lang") || "hy";

i18n.use(initReactI18next).init({
    resources: {
        hy: {
            translation: {
                Sel: "Ընտրել լեզուն",
                li1: "Ծառայություններ",
                li2: "Մեր մասին",
                li3: "Առավելություններ",
                li4: "Կապ",
                zang: "Զանգել",
                text11: "Բարի գալուստ HGH AGRO DRONES",
                text12: "Որտեղ նորարարությունը թռիչք է կատարում, և սկսվում է գյուղատնտեսության ապագան",
                btn2: "Տեսնել մեր ծառայությունները",
                btn3: "Զանգել WhatsApp",
                text13: "Ծառայություններ",
                text14: "Օդային Սրսկում",
                text15: "Օդային սրսկում՝ վերահսկվող նորմերով, ճշգրիտ և հավասարաչափ ծածկույթով։",
                text16: "Հատիկավոր նյութերի սփռում (Spreading)",
                text17: "Չոր հատիկավոր նյութերի արդյունավետ սփռում՝  պարարտանյութերի, սերմացուի, կերային գրանուլների և այլ  նյութերի համար։",
                text18: "Քարտեզագրում և Մոնիթորինգ",
                text19: "Բարձր ճշգրտությամբ տվյալներ ստանալու և ճիշտ որոշումներ ընդունելու համար։",
                text20: "Ջերմոցների տանիքների սպիտակեցում և լվացում",
                text21: "Արագ և անվտանգ իրականացում՝ ժամանակի և ռեսուրսների խնայողությամբ, միատեսակ ծածկույթ՝ նյութի տնտեսապես հիմնավորված սպառումով։",
                text22: "Մեր մասին",
                text23: "HGH AGRO DRONES-ը ստեղծվել է՝ գյուղատնտեսական աշխատանքները դարձնելու ավելի արագ, անվտանգ և արդյունավետ։  Մենք ունենք Հայաստանում ամենամեծ գյուղատնտեսական անօդաչուների պարկը, ինչը թույլ է տալիս իրականացնել մեծածավալ աշխատանքներ՝ կարճ ժամկետներում։  Աշխատում ենք ՀՀ ամբողջ տարածքում՝ ապահովելով որակ,արդյունավետությու և թափանցիկ հաշվետվողականություն։",
                text24: "Առավելություններ",
                text25: "Ավելի անվտանգ",
                text26: "Ավելի քիչ անմիջական շփում քիմիկատների հետ՝ ավելի ապահով  աշխատանքային պայմաններ։ Չի պահանջում դաշտ մտնել տեխնիկայով՝  նվազ ռիսկեր և վնասվածքներ։",
                text27: "Ավելի բազմակողմանի",
                text28: "Աշխատանք դժվար հասանելի/անհարթ տարածքներում՝ լանջեր, անհարթ ռելիեֆ, խոչընդոտներ։ Հարմար է տարբեր դաշտային պայմաններում՝ երբ ավանդական տեխնիկան սահմանափակ է։",
                text29: "Ավելի ճշգրիտ",
                text30: "Ճշգրիտ դոզավորում և հավասար  ծածկույթ՝ վերահսկվող նորմերով։ Հնարավոր է թիրախային մշակում՝ միայն խնդրահարույց գոտիներում։",
                text31: "Տնտեսապես արդյունավետ",
                text32: "Ռեսուրսների օպտիմալացում — նյութի և քիմիկատի օպտիմալ սպառում՝ ջրի, ժամանակի և աշխատուժի խնայողությամբ (մինչև ~30% նվազ կորուստներ՝ ավանդական մեթոդների համեմատ)։",
                text33: "Էկոլոգիապես բարենպաստ",
                text34: "Թիրախային և վերահսկվող կիրառություն՝ օպտիմալ նյութածախսով և շրջակա միջավայրի վրա ավելի քիչ ազդեցությամբ։",
                text35: "Կապ",
                text36: "Կապվեք մեզ հետ",
                text37: "Հարցեր տվեք ցանկացած եղանակով և մենք կկապնվենք ձեզ հետ։",
                text38: "Հեռախոսահամար",
                text39: "+374 33 80 90 09",
                text40: "Էլ. փոստ",
                text41: "info@agrodrone.am",
                text42: "Հասցե",
                text43: "Երևան ,Գևորգ Քոչար 21",
                text44: "Աշխատանքային ժամեր",
                text45: "Երկ-Ուրբ 09:00 – 18:00",
                text46: "Հետևեք մեզ սոցիալական ցանցերում",
                text47: "Դրոններով ցողման ծառայություններ գյուղատնտեսության համար",
                text48: "Ծառայություններ",
                text49: "Օդային Սրսկում",
                text50: "Հատիկավոր նյութերի սփռում (Spreading)",
                text51: "Քարտեզագրում և Մոնիթորինգ",
                text52: "Ջերմոցների տանիքների սպիտակեցում և լվացում",
                text53: "Ընկերություն",
                text54: "Մեր մասին",
                text55: "Առավելություններ",
                text56: "Կապ",
                text57: "Կապ",
                text58: "Հեռ․ +374 33 80 90 09",
                text59: "info@agrodrone.am",
                text60: "Երևան ,Գևորգ Քոչար 21",
                text61: "Սոցիալական ցանցեր",
                text62: "",
                text63: "",
                text64: "",
                text65: "",
                text66: "",
                text67: "",
                text68: "",
                text69: "",
                text70: "",
                text71: "",
                text72: "",
                text73: "",
                text74: "",
                text75: "",
                text76: "",
                text77: "",
                text78: "",
                text79: "",
                text80: "",
                text81: "",
                text82: "",
                text83: "",
                text84: "",
                text85: "",
                text86: "",
                text87: "",
                text88: "",
                text89: "",
                text90: "",
                text91: "",
                text92: "",
                text93: "",
                text94: "",
                text95: "",
                text96: "",
                text97: "",
                text98: "",
                text99: "",
                text100: ""


            }
        },
        ru: {
            translation: {
                Sel: "Выберите язык",
                li1: "Услуги",
                li2: "О нас",
                li3: "Преимущества",
                li4: "Контакты",
                zang: "Вызов",
                text11: "Добро пожаловать в HGH AGRO DRONES",
                text12: "Там, где инновации набирают обороты и зарождается будущее сельского хозяйства",
                btn2: "Ознакомьтесь с нашими услугами",
                btn3: "Позвонить WhatsApp",
                text13: "Услуги",
                text14: "Подача воздуха",
                text15: "Пневматическое распыление с контролируемой скоростью, точное и равномерное покрытие.",
                text16: "Распределение зернистых материалов (Распределение)",
                text17: "Эффективное распределение сухих гранулированных материалов для удобрений, семян, кормовых гранул и других материалов.",
                text18: "Картографирование и мониторинг",
                text19: "Для получения высокоточных данных и принятия правильных решений.",
                text20: "Побелка и мытье крыш теплиц.",
                text21: "Быстрое и безопасное выполнение работ, экономия времени и ресурсов, равномерное покрытие при экономически оправданном расходе материалов.",
                text22: "О нас",
                text23: "Компания HGH AGRO DRONES была создана для того, чтобы сделать сельскохозяйственные работы быстрее, безопаснее и эффективнее. Мы располагаем крупнейшим в Армении парком сельскохозяйственных дронов, что позволяет нам выполнять масштабные работы в короткие сроки. Мы работаем по всей территории Армении, гарантируя качество, эффективность и прозрачную подотчетность.",
                text24: "Преимущества",
                text25: "Безопаснее",
                text26: "Меньший прямой контакт с химическими веществами — более безопасные условия труда. Не требует выхода на поле с оборудованием — меньше рисков и травм.",
                text27: "Более универсальный",
                text28: "Работа в труднодоступных/неровных местах: склоны, неровная местность, препятствия. Подходит для различных полевых условий, где традиционные методы ограничены.",
                text29: "Более точный",
                text30: "Точное дозирование и равномерное покрытие при контролируемой скорости введения. Целенаправленное лечение возможно только в проблемных зонах.",
                text31: "Экономически эффективный",
                text32: "Оптимизация ресурсов — оптимальное потребление материалов и химикатов, экономия воды, времени и трудозатрат (снижение потерь до ~30% по сравнению с традиционными методами).",
                text33: "Экологически чистый",
                text34: "Целенаправленное и контролируемое применение с оптимальным расходом материалов и минимальным воздействием на окружающую среду.",
                text35: "Контакт",
                text36: "Связаться с нами",
                text37: "Задавайте любые вопросы, и мы с вами свяжемся.",
                text38: "Номер телефона",
                text39: "+374 33 80 90 09",
                text40: "Электронная почта",
                text41: "info@agrodrone.am",
                text42: "Адрес",
                text43: "Ереван, Геворг Кочар 21",
                text44: "Рабочее время",
                text45: "Пн-Пт 09:00 – 18:00",
                text46: "Подписывайтесь на нас в социальных сетях!",
                text47: "Услуги по опрыскиванию сельскохозяйственной техники с помощью дронов.",
                text48: "Услуги",
                text49: "Подача воздуха",
                text50: "Распределение зернистых материалов (Spreading)",
                text51: "Картографирование и мониторинг",
                text52: "Побелка и мытье крыш теплиц.",
                text53: "Компания",
                text54: "О нас",
                text55: "Преимущества",
                text56: "Контакт",
                text57: "Контакт",
                text58: "Тел. +374 33 80 90 09",
                text59: "info@agrodrone.am",
                text60: "Ереван, Геворг Кочар 21",
                text61: "Социальные сети",
                text62: "",
                text63: "",
                text64: "",
                text65: "",
                text66: "",
                text67: "",
                text68: "",
                text69: "",
                text70: "",
                text71: "",
                text72: "",
                text73: "",
                text74: "",
                text75: "",
                text76: "",
                text77: "",
                text78: "",
                text79: "",
                text80: "",
                text81: "",
                text82: "",
                text83: "",
                text84: "",
                text85: "",
                text86: "",
                text87: "",
                text88: "",
                text89: "",
                text90: "",
                text91: "",
                text92: "",
                text93: "",
                text94: "",
                text95: "",
                text96: "",
                text97: "",
                text98: "",
                text99: "",
                text100: ""
            }
        },
        en: {
            translation: {
                Sel: "Choose language",
                li1: "Services",
                li2: "About us",
                li3: "Advantages",
                li4: "Contact",
                zang: "Call",
                text11: "Welcome to HGH AGRO DRONES",
                text12: "Where innovation takes flight, and the future of agriculture begins",
                btn2: "See our services",
                btn3: "Call WhatsApp",
                text13: "Services",
                text14: "Air Supply",
                text15: "Air spraying with controlled rates, precise and even coverage.",
                text16: "Spreading of granular materials (Spreading)",
                text17: "Efficient spreading of dry granular materials for fertilizers, seeds, feed pellets and other materials.",
                text18: "Mapping and Monitoring",
                text19: "To obtain highly accurate data and make the right decisions.",
                text20: "Whitewashing and washing of greenhouse roofs",
                text21: "Fast and safe implementation, saving time and resources, uniform coverage with economically justified material consumption.",
                text22: "About us",
                text23: "HGH AGRO DRONES was created to make agricultural work faster, safer and more efficient. We have the largest fleet of agricultural drones in Armenia, which allows us to carry out large-scale work in a short time. We work throughout the territory of Armenia, ensuring quality, efficiency and transparent accountability.",
                text24: "Advantages",
                text25: "Safer",
                text26: "Less direct contact with chemicals - safer working conditions. Does not require entering the field with equipment - fewer risks and injuries.",
                text27: "More versatile",
                text28: "Work in difficult-to-reach/uneven areas: slopes, uneven terrain, obstacles. Suitable for various field conditions where traditional techniques are limited.",
                text29: "More accurate",
                text30: "Precise dosing and even coverage with controlled rates. Targeted treatment is possible, only in problem areas.",
                text31: "Economically efficient",
                text32: "Resource optimization — optimal consumption of material and chemicals, saving water, time and labor (up to ~30% less losses compared to traditional methods).",
                text33: "Environmentally friendly",
                text34: "Targeted and controlled application with optimal material consumption and less impact on the environment.",
                text35: "Contact",
                text36: "Contact us",
                text37: "Ask questions in any way and we will contact you.",
                text38: "Phone number",
                text39: "+374 33 80 90 09",
                text40: "Email",
                text41: "info@agrodrone.am",
                text42: "Address",
                text43: "Yerevan, Gevorg Kochar 21",
                text44: "Working hours",
                text45: "Mon-Fri 09:00 – 18:00",
                text46: "Follow us on social media",
                text47: "Drone spraying services for agriculture",
                text48: "Services",
                text49: "Air Supply",
                text50: "Spreading of granular materials (Spreading)",
                text51: "Mapping and Monitoring",
                text52: "Whitewashing and washing of greenhouse roofs",
                text53: "Company",
                text54: "About us",
                text55: "Advantages",
                text56: "Contact",
                text57: "Contact",
                text58: "Tel. +374 33 80 90 09",
                text59: "info@agrodrone.am",
                text60: "Yerevan, Gevorg Kochar 21",
                text61: "Social networks",
                text62: "",
                text63: "",
                text64: "",
                text65: "",
                text66: "",
                text67: "",
                text68: "",
                text69: "",
                text70: "",
                text71: "",
                text72: "",
                text73: "",
                text74: "",
                text75: "",
                text76: "",
                text77: "",
                text78: "",
                text79: "",
                text80: "",
                text81: "",
                text82: "",
                text83: "",
                text84: "",
                text85: "",
                text86: "",
                text87: "",
                text88: "",
                text89: "",
                text90: "",
                text91: "",
                text92: "",
                text93: "",
                text94: "",
                text95: "",
                text96: "",
                text97: "",
                text98: "",
                text99: "",
                text100: ""



            }
        }
    },
    lng: savedLanguage,
    fallbackLng: "hy",
    interpolation: { escapeValue: false },
});

export default i18n;